import * as types from "../types";
import { fetchCampaignEditLogs } from "../../api";

const getCampaignLogs = (modifiedParams, filters) => {
  return async (dispatch) => {
    dispatch({ type: types.IS_LOGS_LOADING, payload: true });
    try {
      const { page = 1, ps = 25 } = modifiedParams;
      const offset = (page - 1) * ps;
      const data = await fetchCampaignEditLogs(
        modifiedParams.ps,
        offset,
        modifiedParams.sort,
        filters,
        modifiedParams.id
      );
      dispatch({
        type: types.CAMPAIGN_LOGS,
        payload: {
          data: data.data,
          totalCount: data.totalCount,
          isLoading: false,
          error: null,
        },
      });
    } catch (err) {
      const error = err.response ? err.response.data : err;
      dispatch({
        type: types.CAMPAIGN_LOGS,
        payload: {
          data: [],
          totalCount: 0,
          isLoading: false,
          error,
        },
      });
    }
    dispatch({ type: types.IS_LOGS_LOADING, payload: false });
  };
};

export { getCampaignLogs };
